import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@mui/material';

import { InvalidFlow } from '../validation/types';

type Props = {
  error: InvalidFlow;
  /** Names the flow when several flows are shown together (multi-edit) */
  flowName?: string;
};

/** @description A validation error of a flow, e.g. a misconfigured consolidation */
function FlowErrorComponent({ error: { reason, context }, flowName }: Props) {
  const { t } = useTranslation();

  return (
    <Alert severity='error'>
      {flowName && <AlertTitle>{flowName}</AlertTitle>}
      {t(`errors:flow.${reason}`, { ...context })}
    </Alert>
  );
}

export const FlowError = memo(FlowErrorComponent);
